import { Controller } from '@hotwired/stimulus';

export default class ProfileMenuController extends Controller {
  static targets = ['menu'];
  static values = {
    scrollPosition: Number,
  };

  saveScroll() {
    this.scrollPositionValue = window.scrollY;
  }

  restoreScroll() {
    window.scrollTo({ top: this.scrollPositionValue, behavior: 'auto' });
  }

  closeOnOutsideClick(event) {
    if (!this.menuTarget.classList.contains('show')) return;
    if (this.element.contains(event.target)) return;

    bootstrap.Collapse.getInstance(this.menuTarget)?.hide();
  }
}
